// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"139":"1a8f054ce3102c26","646":"0e636499d87f8634"}[chunkId] + ".js";
};